import { useState } from "react";
import { orderServices } from "../services/orderService";

export const useOrderWhatsApp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [orderData, setOrderData] = useState(null);

  const createOrder = async ({ items, shipping_address, customer_phone }) => {
    setLoading(true);
    setError(null);
    try {
      // Validações básicas
      if (!items || !Array.isArray(items) || items.length === 0) {
        throw new Error("Items array is required");
      }

      if (!shipping_address) {
        throw new Error("Shipping address is required");
      }

      if (!customer_phone) {
        throw new Error("Customer phone is required");
      }

      // Garante que cada item tem product_id e quantity
      const validItems = items.every(
        (item) =>
          item.product_id &&
          typeof item.quantity === "number" &&
          item.quantity > 0
      );

      if (!validItems) {
        throw new Error("Each item must have a valid product_id and quantity");
      }

      const response = await orderServices.createOrderWhatsApp({
        items,
        shipping_address,
        customer_phone,
      });

      setOrderData(response);
      return response;
    } catch (err) {
      const errorMessage = err.message || "Erro ao criar pedido";
      setError(errorMessage);
      throw errorMessage;
    } finally {
      setLoading(false);
    }
  };

  return {
    createOrder,
    loading,
    error,
    orderData,
  };
};
